var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-inline-flex dropdown" }, [
    _vm.triggers
      ? _c(
          "a",
          {
            staticClass: "dropdown-toggle",
            class: _vm.dropdownContainerClass,
            attrs: { "data-toggle": "dropdown" },
          },
          [
            _c("span", { staticClass: "bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.currentText.replace(
                      _vm.currentText.split(" ").pop(),
                      ""
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "bold", style: { color: _vm.textColor } },
              [_vm._v(_vm._s(_vm.currentText.split(" ").pop()))]
            ),
          ]
        )
      : _c(
          "a",
          {
            staticClass: "dropdown-toggle",
            class: _vm.dropdownContainerClass,
            attrs: { "data-toggle": "dropdown" },
          },
          [
            _c("span", { staticClass: "bold" }, [
              _vm._v("\n      " + _vm._s(_vm.currentText) + "\n    "),
            ]),
          ]
        ),
    _vm._v(" "),
    !_vm.readOnly
      ? _c(
          "div",
          { staticClass: "dropdown-menu" },
          [
            _vm._l(_vm.itemsToRender, function (item, index) {
              return _vm._t(
                "items",
                function () {
                  return [
                    _c(
                      "a",
                      {
                        key: index,
                        staticClass: "dropdown-item clickable",
                        on: {
                          click: function ($event) {
                            return _vm.select(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.name) + "\n      ")]
                    ),
                  ]
                },
                { item: item }
              )
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }